<template>
  <el-dialog title="跟进线索" :visible.sync="visible" width="600px">
    <el-form :model="form" label-width="120px" :rules="rules" ref="followForm">
      <el-form-item label="线索编号">
        <el-input v-model="form.clueNo" :disabled="true" />
      </el-form-item>
      <el-form-item label="服务者姓名">
        <el-input v-model="form.workerName" :disabled="true" />
      </el-form-item>
       <el-form-item label="导入标签">
        <el-input v-model="form.importLabel" :disabled="true" />
      </el-form-item>
       <el-form-item label="是否符合">
        <el-input v-model="form.satisfy" :disabled="true" />
      </el-form-item>
      <el-form-item  label="跟进结果" prop="followResult">
        <el-select v-model="form.followResult" placeholder="请选择跟进结果">
          <el-option label="继续跟进" :value="1"></el-option>
          <el-option label="邀约面试" v-if="tempRow.state==2" :value="2"></el-option>
          <el-option label="跟进失败" :value="3"></el-option>

          <el-option v-if="tempRow.state==12" label="(流失)面试未通过"  :value="4"></el-option>
          <el-option v-if="tempRow.state==3" label="(流失)培训未通过"  :value="5"></el-option>
          <el-option v-if="tempRow.state==3" label="(流失)跟单未通过"  :value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进内容" prop="followContent">
        <el-input v-model="form.followContent" type="textarea" :rows="4" placeholder="请输入跟进内容" />
      </el-form-item>

      <el-form-item label="下次跟进时间" prop="followTime" v-if="form.followResult == 1">
        <div class="follow-time-picker-wrapper">
          <el-date-picker v-model="form.followTime" :append-to-body="false"
            popper-class="worker-follow-time-picker" type="datetime" placeholder="请选择下次跟进时间" />
        </div>
      </el-form-item>
      <el-form-item label="跟进失败原因" prop="loseReason" v-if="form.followResult == 3">
        <el-cascader style="width:100%;" v-model="form.loseReason" filterable placeholder="请选择跟进失败原因":options="loseReasonList" :props="optionProps">
          <template slot-scope="{ node, data }">
            <span>{{ data.typeValue }}</span>
            <span v-if="!node.isLeaf">({{ data.childList.length }})</span>

          </template>
        </el-cascader>
      </el-form-item>

      <el-form-item label="是否添加微信" prop="addWeixin">
         <el-select v-model="form.addWeixin" placeholder="请选择是否添加微信" clearable>
            <el-option label="是" :value="1"></el-option>
             <el-option label="否" :value="0"></el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="微信号" prop="wxAccount">
          <el-input v-model="form.wxAccount"  placeholder="请输入微信账号" />
      </el-form-item>


    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import workercrmapi from "@/script/api/workercrmapi";
import globalData from '@/components/common/globaldata/global.data';
export default {
  data() {
    return {
      visible: false,
      tempRow:{},
      form: {
        clueId: '',
        cityId: '',
        clueNo: '',
        workerName: '',
        importLabel: '',
        satisfy: '',
        followContent: '',
        followResult: '',
        followTime: '',
        loseReason: [],
        operName:'',
        addWeixin:'',
        wxAccount:''
      },
      loseReasonList: [],
      optionProps: {
                value: "type",
                label: "typeValue",
                children: "childList",
                multiple: true,
                //  checkStrictly: true
            },
      rules: {
        followContent: [
          { required: true, message: '请输入跟进内容', trigger: 'blur' }
        ],
        followResult: [
          { required: true, message: '请选择跟进结果', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    showFollow(row) {
      this.visible = true;
      this.tempRow=row;
      this.form.clueId = row.id;
      this.form.cityId = row.cityId;
      this.form.clueNo = row.clueNo;
      this.form.workerName = row.workerName;
      this.form.importLabel = row.importLabel;
      this.form.satisfy = row.satisfy;  

      this.form.followContent = '';
      this.form.followResult = '';
      this.form.operName = globalData.userInfo.userName;
      this.form.addWeixin='';
      this.form.wxAccount='';

      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.followForm) {
          this.$refs.followForm.clearValidate();
        }
        //清除时间
        this.form.followTime = '';
        this.form.loseReason = [];
      });

      if(this.loseReasonList.length==0){
        this.getLoseReasonList();
      }
    },
    handleConfirm() {
      this.$refs.followForm.validate((valid) => {
        if (valid) {
          if(this.form.followResult==1&&(this.form.followTime==null||this.form.followTime=='')){
             this.$message.error('请选择下次跟进时间');
            return;
          }
          this.$emit('confirm', { ...this.form });
          this.visible = false;
        } else {
          return false;
        }
      });
    },
    getLoseReasonList(){
      workercrmapi.$axiosgetLossleaveDict({type:2}).then(res => {
        if(res.data.errno==0){
          this.loseReasonList = res.data.data;
        }
      });
    }
  }
}
</script>

<style scoped>
.follow-time-picker-wrapper >>> .worker-follow-time-picker {
  position: absolute !important;
  top: auto !important;
  right: auto !important;
  bottom: calc(100% + 8px) !important;
  left: 0 !important;
  margin: 0 !important;
  transform: none !important;
}

.follow-time-picker-wrapper >>> .worker-follow-time-picker .popper__arrow {
  display: none;
}
</style>
